import * as XLSX from 'xlsx';

export const convertObjToQueryParams = (obj) => {
    let query = ""
    let keys = Object.keys(obj);
    for (let i = 0; i < keys?.length; i++) {
        if (i == 0) {
            query += `?`
        } else {
            query += `&`
        }
        query += `${keys[i]}=${obj[keys[i]]}`
    }
    return query;
};

export const jsonToXlsx = (data, sheetName, fieldOrder) => {
    let filteredData = [];
    data.forEach(element => {
        switch (sheetName) {
            case "credit-card-dashboard":
            case "loan-application-dashboard":
                filteredData.push({
                    "Name": element.customer_full_name,
                    "Mobile Number": element.customer_mobile_number,
                    "Logged In Application": element.loggedInApps,
                    "Pan Number": element.pan_number,
                });
                break;
            default:
                filteredData.push(element);
        }
        if (element.chidlren?.length) {
            element.chidlren.forEach(el => {
                switch (sheetName) {
                    case "credit-card-dashboard":
                    case "loan-application-dashboard":
                        filteredData.push({
                            "Name": el.customer_full_name,
                            "Mobile Number": el.customer_mobile_number,
                            "Logged In Application": el.loggedInApps,
                            "Pan Number": el.pan_number,
                        });
                        break;
                    default:
                        filteredData.push(el);
                }
            });
        }
    });

    const workbook = XLSX.utils.book_new();
    let worksheet;
    if (fieldOrder) {
        worksheet = XLSX.utils.json_to_sheet(filteredData.length ? filteredData : data, { header: fieldOrder });
    } else {
        worksheet = XLSX.utils.json_to_sheet(filteredData.length ? filteredData : data);
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, "xlsxSheet");
    XLSX.writeFile(workbook, sheetName + (new Date()).getMilliseconds() + ".xlsx");
};

export const toBase64 = (file) => {
    const promise = new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            resolve(reader?.result?.split(",")[1]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    })
    return promise
}
